/*
 * Author: Roger
 * File Created: Thursday, 24-08-08 10:35 am
 * Last Modified: Tuesday, 24-08-20 05:14 pm, by Roger
 */

const Reward = () => {
  return (
    <svg fill="none" viewBox="0 0 81 80" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5732_2361)">
        <path
          d="M21.2053 58.8306C31.5943 58.8306 40.0162 50.4087 40.0162 40.0198C40.0162 29.6309 31.5943 21.209 21.2053 21.209C10.8164 21.209 2.39453 29.6309 2.39453 40.0198C2.39453 50.4087 10.8164 58.8306 21.2053 58.8306Z"
          fill="#7E61F3"
        />
        <path
          d="M22.1581 45.0493C21.8035 45.3866 20.9473 45.6287 19.9181 45.352C18.9235 45.0839 18.3008 44.4698 18.1408 44.0114C17.8597 43.1941 16.9689 42.7617 16.156 43.0428C15.3387 43.3239 14.9062 44.2147 15.1873 45.0276C15.7235 46.5844 17.2284 47.8644 19.1095 48.3703C19.6803 48.5217 20.2554 48.5995 20.8089 48.5995C22.1711 48.5995 23.4295 48.1541 24.3073 47.3195C24.9343 46.7271 24.9603 45.7368 24.3635 45.1098C23.7711 44.4828 22.7808 44.4568 22.1538 45.0536L22.1581 45.0493Z"
          fill="white"
        />
        <path
          d="M17.3833 36.3794C17.5174 36.414 17.6558 36.4313 17.7898 36.4313C18.4817 36.4313 19.1131 35.9729 19.299 35.2723L20.0342 32.5264C20.259 31.6918 19.7617 30.8356 18.9315 30.6107C18.0969 30.3859 17.2406 30.8832 17.0158 31.7134L16.2806 34.4594C16.0558 35.294 16.5531 36.1502 17.3833 36.375V36.3794Z"
          fill="white"
        />
        <path
          d="M28.2088 33.101C27.3742 32.8761 26.518 33.3734 26.2931 34.2037L25.558 36.9496C25.3331 37.7842 25.8304 38.6404 26.6607 38.8653C26.7947 38.8999 26.9331 38.9172 27.0672 38.9172C27.7591 38.9172 28.3904 38.4588 28.5764 37.7583L29.3115 35.0123C29.5364 34.1777 29.0391 33.3215 28.2088 33.0966V33.101Z"
          fill="white"
        />
        <path
          d="M59.8814 19C51.2197 19 43.7776 24.3276 40.6641 31.8735C37.5462 24.3276 30.1084 19 21.4468 19C9.98731 19 0.664062 28.3232 0.664062 39.7827C0.664062 51.2422 9.98731 60.5654 21.4468 60.5654C30.1084 60.5654 37.5505 55.2378 40.6641 47.6919C43.7819 55.2422 51.2197 60.5654 59.8814 60.5654C71.3408 60.5654 80.6641 51.2422 80.6641 39.7827C80.6641 28.3232 71.3408 19 59.8814 19ZM21.4468 58.3514C11.2068 58.3514 2.87812 50.0227 2.87812 39.7827C2.87812 29.5427 11.2068 21.2097 21.4468 21.2097C31.6868 21.2097 40.0154 29.5384 40.0154 39.7784C40.0154 50.0184 31.6868 58.347 21.4468 58.347V58.3514ZM59.8814 58.3514C49.6414 58.3514 41.3084 50.0184 41.3084 39.7784C41.3084 29.5384 49.6414 21.2097 59.8814 21.2097C70.1214 21.2097 78.4543 29.5427 78.4543 39.7827C78.4543 50.0227 70.1214 58.3557 59.8814 58.3557V58.3514Z"
          fill="white"
        />
        <path
          d="M65.1728 43.0389C64.3555 42.7578 63.469 43.1902 63.1879 44.0075C63.0279 44.4659 62.4052 45.0843 61.4106 45.3481C60.3814 45.6248 59.5296 45.387 59.1706 45.0454C58.5436 44.4529 57.5577 44.4745 56.9609 45.1016C56.3685 45.7286 56.3901 46.7145 57.0171 47.3113C57.895 48.1459 59.1577 48.5913 60.5155 48.5913C61.0733 48.5913 61.6442 48.5178 62.215 48.3621C64.096 47.8562 65.6009 46.5762 66.1371 45.0194C66.4182 44.2021 65.9858 43.3156 65.1685 43.0345L65.1728 43.0389Z"
          fill="white"
        />
        <path
          d="M62.0317 35.2722C62.2176 35.9684 62.849 36.4311 63.5409 36.4311C63.6749 36.4311 63.809 36.4138 63.9474 36.3792C64.782 36.1544 65.2749 35.2982 65.0501 34.4636L64.3149 31.7176C64.0901 30.883 63.2339 30.3901 62.3993 30.6149C61.5647 30.8398 61.0717 31.696 61.2966 32.5306L62.0317 35.2765V35.2722Z"
          fill="white"
        />
        <path
          d="M55.0337 34.2039C54.8088 33.3694 53.9526 32.8764 53.118 33.1012C52.2834 33.3261 51.7904 34.1823 52.0153 35.0169L52.7504 37.7629C52.9364 38.4591 53.5677 38.9218 54.2596 38.9218C54.3937 38.9218 54.5277 38.9045 54.6661 38.8699C55.5007 38.645 55.9937 37.7888 55.7688 36.9542L55.0337 34.2083V34.2039Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5732_2361">
          <rect
            fill="white"
            height="80"
            transform="translate(0.664062)"
            width="80"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Reward;
